/**
 * Блок «Компоненты Картилокс Т» на странице /cartilox-t/.
 *
 * Сам аккордеон — общий модуль accordion (js-accordion / js-accordion-item).
 * Этот модуль отвечает за две вещи:
 *   1) левая колонка на десктопе: пока всё закрыто, там заголовок; как только
 *      пункт раскрывают — вместо заголовка появляется картинка компонента;
 *   2) плавный сдвиг названия пункта (FLIP). В раскрытом пункте по макету нет
 *      цифры, и её место освобождается мгновенно (иначе название в переходном
 *      состоянии не влезает в строку) — название прыгало влево на ширину цифры.
 *      Здесь мы замеряем сдвиг и гасим его transform'ом, а CSS-переход
 *      (.t-components__name { transition: transform }) доводит его до нуля.
 *
 * Хуки — data-атрибуты и js-классы, чтобы не зависеть от БЭМ-имён.
 */
itsoftApp.createModule("tComponents", ["windowResize"], function () {
    const module = this;

    const TComponents = function (container) {
        if (!container) {
            return;
        }

        this.container = container;
        this.items = container.querySelectorAll(".js-accordion-item");
        this.images = container.querySelectorAll(".js-t-components-img");

        this.classNames = {
            active: "_active",
            mediaActive: "_media-active",
            itemActive: "js-accordion-item--active"
        };

        this.init();
    };

    TComponents.prototype.init = function () {
        const self = this;

        Array.prototype.forEach.call(this.items, function (item) {
            const head = item.querySelector(".js-accordion-head");

            self.watchName(item);

            if (!head) {
                return;
            }

            /*
             * aria-expanded у кнопки шапки — по классу пункта: раскрывает его
             * общий модуль accordion, поэтому следим за классами, а не за кликом
             */
            const syncExpanded = function () {
                head.setAttribute("aria-expanded", item.classList.contains(self.classNames.itemActive) ? "true" : "false");
            };

            new MutationObserver(syncExpanded).observe(item, { attributes: true, attributeFilter: ["class"] });
            syncExpanded();

            head.addEventListener("click", function () {
                /* Клик по уже раскрытому пункту закрывает его — тогда возвращаем заголовок */
                if (item.classList.contains(self.classNames.itemActive)) {
                    self.setImage(null);
                    return;
                }

                self.setImage(item.getAttribute("data-component"));
            });
        });

        const refresh = this.refreshNames.bind(this);

        this.container.addEventListener("click", refresh, true);
        this.container.addEventListener("transitionend", refresh, true);
        itsoftApp.modules.windowResize.addEvent(refresh);

        const opened = this.container.querySelector("." + this.classNames.itemActive);
        this.setImage(opened ? opened.getAttribute("data-component") : null);
    };

    /**
     * Положение названия внутри пилюли. Берём offsetLeft/offsetTop, а не
     * getBoundingClientRect: они не зависят ни от прокрутки, ни от transform,
     * который в этот момент может ещё доигрывать с прошлого переключения.
     */
    const nameOffset = function (name) {
        return { x: name.offsetLeft, y: name.offsetTop };
    };

    /**
     * FLIP: смена классов аккордеона мгновенно переносит название на новое
     * место, поэтому в тот же кадр возвращаем его трансформом назад и сразу
     * отпускаем — CSS-переход доводит его плавно.
     */
    TComponents.prototype.watchName = function (item) {
        const name = item.querySelector(".t-components__name");

        if (!name || typeof MutationObserver === "undefined") {
            return;
        }

        item.nameFlip = { name: name, offset: nameOffset(name) };

        const observer = new MutationObserver(function () {
            const flip = item.nameFlip;
            const next = nameOffset(name);
            const shiftX = flip.offset.x - next.x;
            const shiftY = flip.offset.y - next.y;

            flip.offset = next;

            if (Math.abs(shiftX) < 1 && Math.abs(shiftY) < 1) {
                return;
            }

            name.style.transition = "none";
            name.style.transform = "translate(" + shiftX + "px, " + shiftY + "px)";

            /* Принудительный пересчёт: без него обе правки схлопнутся в одну и перехода не будет */
            name.getBoundingClientRect();

            name.style.transition = "";
            name.style.transform = "";
        });

        observer.observe(item, { attributes: true, attributeFilter: ["class"] });
    };

    /**
     * Обновить базу FLIP у всех пунктов.
     *
     * Кэшировать её один раз на старте нельзя: пока грузится шрифт, метрики
     * названия меняются, и первое же раскрытие уезжает на разницу. Поэтому
     * базу снимаем прямо перед тем, как общий модуль аккордеона переставит
     * классы, — в фазе ПЕРЕХВАТА, до его собственных обработчиков:
     * `click` — раскрытие, `transitionend` — закрытие (в том числе соседнего
     * пункта, по которому не кликали).
     */
    TComponents.prototype.refreshNames = function () {
        Array.prototype.forEach.call(this.items, function (item) {
            if (item.nameFlip) {
                item.nameFlip.offset = nameOffset(item.nameFlip.name);
            }
        });
    };

    TComponents.prototype.setImage = function (key) {
        const self = this;

        Array.prototype.forEach.call(this.images, function (image) {
            const isActive = key !== null && image.getAttribute("data-component") === key;
            image.classList.toggle(self.classNames.active, isActive);
        });

        this.container.classList.toggle(this.classNames.mediaActive, key !== null);

        DEBUG && console.log("[module tComponents] active component: " + key);
    };

    /*
     * Заголовок блока покрашен градиентом через background-clip: text. Маска
     * клипа — это глифы ВСЕХ потомков, их filter/opacity она не учитывает,
     * поэтому пословная анимация (animateTitle оборачивает слова в <i> с
     * blur + opacity) была не видна: слова горели сразу. После разбивки
     * градиент переезжает на каждое слово (CSS: .t-components__title._show),
     * а здесь ему задаётся размер всего заголовка и сдвиг на позицию слова —
     * так картинка совпадает с прежней, общей на заголовок.
     */
    const paintTitleWords = function (title) {
        const words = title.querySelectorAll("i");

        if (!words.length) {
            return;
        }

        const size = title.offsetWidth + "px " + title.offsetHeight + "px";

        Array.prototype.forEach.call(words, function (word) {
            word.style.backgroundSize = size;
            word.style.backgroundPosition = -word.offsetLeft + "px " + -word.offsetTop + "px";
        });
    };

    const initTitle = function (title) {
        const repaint = function () {
            paintTitleWords(title);
        };

        // слова появляются, когда animateTitle ставит _show
        new MutationObserver(repaint).observe(title, { childList: true });
        itsoftApp.modules.windowResize.addEvent(repaint);

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(repaint);
        }

        repaint();
    };

    const initTComponents = function () {
        const containers = document.querySelectorAll(".js-t-components");

        Array.prototype.forEach.call(containers, function (el) {
            if (!el.tComponents) {
                el.tComponents = new TComponents(el);
            }
        });

        Array.prototype.forEach.call(document.querySelectorAll(".js-t-components-title"), initTitle);
    };

    initTComponents();

    module.callback = TComponents;
});
